(function () {
  'use strict'

  angular.module('MktzapApp.Controllers')
    .controller('ProfilePermissionControlController', profilePermissionControlController);

  profilePermissionControlController.$inject = ['$window', '$scope', '$rootScope', '$http', '$stateParams', '$location', 'ProfilePermissionControlService', 'FoundationApi', 'UserService', 'UserAuditService', '$state', 'NumberService', 'EmailService', 'ChatService', 'SectorService', 'FacebookService', 'Upload', '$timeout', 'NotificationFactory', 'UserSignatureService', 'DashboardService', 'StatusService', 'NotificationService', 'SesameAuthService', 'ValidateService', 'ngTableParams', 'ProfileService', 'PermissionControlRoutes', 'LangService'];

  function profilePermissionControlController($window, $scope, $rootScope, $http, $stateParams, $location, ProfilePermissionControlService, FoundationApi, UserService, UserAuditService, $state, NumberService, EmailService, ChatService, SectorService, FacebookService, Upload, $timeout, NotificationFactory, UserSignatureService, DashboardService, StatusService, NotificationService, SesameAuthService, ValidateService, ngTableParams, ProfileService, PermissionControlRoutes, LangService) {
    var vm = this;
    vm.permissionControl = {};
    vm.permissionControl.subModules = {};
    vm.permissionControl.count = 0
    vm.add = {};
    vm.edit = {};
    vm.delete = {};

    LangService
      .getPageLabels({ 'page': 'permission.control.modules' })
      .$promise
      .then(function (data) {
        vm.labelsPage = data.lang;
      });

    LangService
      .getPageLabels({ 'page': 'permission.control.subModules' })
      .$promise
      .then(function (data) {
        vm.labelsSubModules = data.lang;
      });

    LangService
      .getPageLabels({ 'page': 'permission.control.actions' })
      .$promise
      .then(function (data) {
        vm.labelsActions = data.lang;
      });

    function validateFormRegister() {
      if (vm.add.type == 'module') {
        if (!vm.add.moduleName) {
          NotificationService.errorHandler({}, $rootScope.labels.fieldModuleNameIsRequired);
          return false;
        }

        return true;
      }

      if (!vm.add.moduleId) {
        NotificationService.errorHandler({}, $rootScope.labels.fieldModuleIdIsRequired);
        return false;
      }

      if (vm.add.type == 'subModule') {
        if (!vm.add.subModuleName) {
          NotificationService.errorHandler({}, $rootScope.labels.fieldSubModuleNameIsRequired);
          return false;
        }

        return true;
      }

      if (!vm.add.subModuleId) {
        NotificationService.errorHandler({}, $rootScope.labels.fieldSubModuleIdIsRequired);
        return false;
      }

      if (!vm.add.actionName) {
        NotificationService.errorHandler({}, $rootScope.labels.fieldActionNameIsRequired);
        return false;
      }

      return true;
    }

    function getPermissions() {
      vm.permissionControl = {};

      PermissionControlRoutes
        .getAll()
        .$promise
        .then(data => {
          if (!data.modules) {
            return false;
          }
          vm.permissionControl.all = data.modules
          vm.permissionControl.count = data.modules.length

          mountPaginate();
        }).catch(data => {
          NotificationService.errorHandler({}, $rootScope.labels.errorGetInfo);
        })
    }

    function mountPaginate() {
      const [countDatas, datasEnabled] = getDatasEnabledShow();
      
      vm.tableParams = new ngTableParams({
          page: 1,
          count: 20,
      }, {
          total: countDatas,
          getData: function($defer, params) {
            $defer.resolve(datasEnabled.slice((params.page() - 1) * params.count(), params.page() * params.count()))
            params.total(countDatas)
          }
      })
    }

    function getDatasEnabledShow() {
      let count = 0;
      let datas = [];

      vm.permissionControl.all.forEach(function (valueModule) {
        if (valueModule.show !== false) {
          count ++;
          datas.push(valueModule);
        }
      });

      return [count, datas];
    }

    function searchName(type, element, show = 'false') {
      if (show === true || !vm.permissionControl.filter) {
        return true;
      }

      let lang = vm.labelsPage;
      if (type == 'subModule') {
        lang = vm.labelsSubModules;
      }

      if (type == 'action') {
        lang = vm.labelsActions;
      }

      if (element.name.toLowerCase().indexOf(vm.permissionControl.filter.toLowerCase()) >= 0 ||
        lang[element.name] && lang[element.name].toLowerCase().indexOf(vm.permissionControl.filter.toLowerCase()) >= 0) {
        return true;     
      }

      return false;
    }

    vm.openRegisterModal = function () {
      vm.add = {};
      FoundationApi.publish('registerPermissionModal', 'open');
    }

    vm.registerPermission = function () {
      if (!validateFormRegister()) {
        return false;
      }

      let action = ProfilePermissionControlService.registerModule;
      if (vm.add.type == 'subModule') {
        action = ProfilePermissionControlService.registerSubModule;
      }

      if (vm.add.type == 'action') {
        action = ProfilePermissionControlService.registerAction;
      }

      action(vm.add)
        .$promise
        .then(function (data) {
          if (data.error) {
            NotificationService.errorHandler({}, data.message);
            return false;
          }

          NotificationService.successHandler({}, data.message);

          FoundationApi.publish('registerPermissionModal', 'close');
          getPermissions();

        }).catch(function (data) {
          NotificationService.errorHandler({}, $rootScope.labels.internalServerError);
        });
      }

    vm.openEditModal = function (type, data) {
      if (!type || !data.id || !data.name) {
        NotificationService.errorHandler({}, $rootScope.labels.errorTryAgain);
        return false;
      }

      vm.edit = {};
      vm.edit.id = data.id;
      vm.edit.name = data.name;
      vm.edit.type = type;

      ProfilePermissionControlService
        .getLinkedPermissions(vm.edit)
        .$promise
        .then(function (data) {
          if (data.error) {
            NotificationService.errorHandler({}, data.message);
            return false;
          }

          vm.edit.linked = data.message.linked;
        }).catch(function (data) {
          NotificationService.errorHandler({}, data.message);
        });


      FoundationApi.publish('editPermissionModal', 'open');

    }

    vm.editPermission = function () {

      if (!vm.edit.id || !vm.edit.type || !vm.edit.name) {
        NotificationService.errorHandler({}, $rootScope.labels.errorTryAgain);
        return false;
      }

      let action = ProfilePermissionControlService.updateModule;
      if (vm.edit.type == 'subModule') {
        action = ProfilePermissionControlService.updateSubModule;
      }

      if (vm.edit.type == 'action') {
        action = ProfilePermissionControlService.updateAction;
      }

      action(vm.edit)
        .$promise
        .then(function (data) {
          if (data.error) {
            NotificationService.errorHandler({}, data.message);
            return false;
          }

          NotificationService.successHandler({}, data.message);

          FoundationApi.publish('editPermissionModal', 'close');
          getPermissions();

        }).catch(function (data) {
          NotificationService.errorHandler({}, $rootScope.labels.internalServerError);
        });
    }

    vm.openDeleteModal = function (type, data) {
      if (!type || !data.id || !data.name) {
        NotificationService.errorHandler({}, $rootScope.labels.errorTryAgain);
        return false;
      }

      vm.delete = {};
      vm.delete.id = data.id;
      vm.delete.name = data.name;
      vm.delete.type = type;

      ProfilePermissionControlService
        .getLinkedPermissions(vm.delete)
        .$promise
        .then(function (data) {
          if (data.error) {
            NotificationService.errorHandler({}, data.message);
            return false;
          }
          
          vm.delete.linked = data.message.linked;
        }).catch(function (data) {
          NotificationService.errorHandler({}, data.message);
        });

      FoundationApi.publish('deletePermissionModal', 'open');

    }

    vm.deletePermission = function () {
      if (!vm.delete.id || !vm.delete.type) {
        NotificationService.errorHandler({}, $rootScope.labels.errorTryAgain);
        return false;
      }

      let action = ProfilePermissionControlService.deleteModule;
      if (vm.delete.type == 'subModule') {
        action = ProfilePermissionControlService.deleteSubModule;
      }

      if (vm.delete.type == 'action') {
        action = ProfilePermissionControlService.deleteAction;
      }

      action(vm.delete)
        .$promise
        .then(function (data) {
          if (data.error) {
            NotificationService.errorHandler({}, data.message);
            return false;
          }

          NotificationService.successHandler({}, data.message);
          
          FoundationApi.publish('deletePermissionModal', 'close')
          getPermissions();
        }).catch(function (data) {
          NotificationService.errorHandler({}, $rootScope.labels.internalServerError);
        });
    }

    vm.alterDisplay = function (display) {
      if (display === true) {
        return false;
      }

      return true;
    }

    vm.alterSubModule = function () {

      if(!vm.add.moduleId) {
        return false;  
      }

      let sub = vm.permissionControl.all.find(i => i.id == vm.add.moduleId);
      vm.permissionControl.subModules = sub.sub_modules;
    }

    vm.searchPermission = function () {
      vm.permissionControl.count = 0

      vm.permissionControl.all.forEach(function (valueModule, indexModule) {
        vm.permissionControl.all[indexModule].show = searchName('module', valueModule)

        valueModule.sub_modules.forEach(function (valueSubModule) {
          vm.permissionControl.all[indexModule].show = searchName('subModule', valueSubModule, vm.permissionControl.all[indexModule].show)

          valueSubModule.actions.forEach(function (valueAction) {
            vm.permissionControl.all[indexModule].show = searchName('action', valueAction, vm.permissionControl.all[indexModule].show)
          });

        });

        if (vm.permissionControl.all[indexModule].show === true) {
          vm.permissionControl.count ++;
        }
      });

      mountPaginate();
    }

    getPermissions();

  }
})();
